import Message from '~/features/chatbot/components/message'
import { TChatMessage } from '~/features/chatbot/models'
import { isPreChatFormSubmissionMessage } from '~/features/chatbot/utils'
import PreChatFormSubmissionMessage from '~/features/chatbotV2/components/dialog/chatDialogMessage/preChatFormSubmissionMessage'

type TProps = {
  chatMessage: TChatMessage
}

function ChatDialogMessage({ chatMessage }: TProps) {
  if (isPreChatFormSubmissionMessage(chatMessage)) {
    return (
      <PreChatFormSubmissionMessage data={chatMessage.preChatFormSubmission} />
    )
  }

  return <Message speaker={chatMessage.speaker} message={chatMessage.message} />
}

export default ChatDialogMessage
